import React from "react";
import settings from './Settings';
export const Indicator = ({ offset }) => {
  const translateX = settings.baseWidth * offset;
  const styles = {
    transform: `translateX(${translateX}${settings.baseUnit})`
  };
  return (<span className="ribbon-element-indicator" style={styles} />);
};
